import React from 'react';
import styled from 'styled-components';
import times from 'lodash/times';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../../CommonComponents/OPL/Shimmer/Shimmer';

const Grid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 70px',
  gap: '10px min(120px, 10vw)',
});

export const ClientsLoading = () => {
  return (
    <Grid>
      {times(6).map(key => (
        <Shimmer key={key} height={24} width="100%" />
      ))}
    </Grid>
  );
};
